import { useContext } from "react";
import {
  Button,
  FormControlLabel,
  Grid,
  Switch,
  Typography,
} from "@mui/material";
import SettingsEditor from "components/SettingsEditor/SettingsEditor";
import MessageEditor from "components/MessageEditor/MessageEditor";
import AppStateContext from "contexts/AppStateContext";
import useStateWithSessionStorage from "hooks/UseStateWithSessionStorage";

const SettingsUI = () => {

  const [debug, setDebug] = useStateWithSessionStorage(false, "debug");
  const { setShowMaintenanceReminder } = useContext(AppStateContext);

  return (
    <Grid container>
      <Grid item xs={12}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            paddingTop: "20px",
            justifyContent: "space-between",
            background: "var(--header)",
            color: "#fff",
            height: "6vh",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              paddingRight: "10px",
            }}
          >
            <Typography
              fontWeight={"bold"}
              variant={"h6"}
              style={{
                textTransform: "uppercase",
                color: "#fff",
                paddingLeft: "1rem",
              }}
            >
              &nbsp;Settings
            </Typography>
          </div>
        </div>
      </Grid>
      <Grid item xs={12} style={{ padding: "1rem 1.5rem 0 1.5rem" }}>
        <FormControlLabel
          control={
            <Switch
              checked={debug}
              onChange={(event) => {
                setDebug(event.target.checked);
              }}
              name="debug"
              color="primary"
            />
          }
          label="Debug Mode"
        />

        <div style={{ paddingTop: "1rem" }}>
          <Typography variant={"subtitle1"} fontWeight={"bold"}>
            Machine maintenance reminder
          </Typography>
          <Typography variant={"body2"} style={{ paddingBottom: "0.5rem" }}>
            The reminder pops up every 15 minutes between 06:00 and 07:00 and
            between 13:00 and 14:00. Use the button to show it right now — a
            manual preview is not remembered and does not affect the real
            reminders.
          </Typography>
          <Button
            variant={"contained"}
            color={"primary"}
            onClick={() => setShowMaintenanceReminder(true)}
          >
            Show reminder now
          </Button>
        </div>

        <MessageEditor />

        <SettingsEditor />

      </Grid>
    </Grid>
  );
};

export default SettingsUI;
